module.exports = __webpack_public_path__ + "img/mfl-left-arrow.d01d0ce6.svg";